import {
  PromotionListParametersType,
  PromotionListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";

export const usePromotionList = <TData = PromotionListResponseType,>(
  params: PromotionListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [business?.id, ServerStateKeys.Promotions, params],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "promotions",
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
